import {
    fetchRoomTypes as apiFetchRoomTypes,
    addRoomType as apiAddRoomType,
    updateRoomType as apiUpdateRoomType,
    deleteRoomType as apiDeleteRoomType,
  } from '../../api/roomType'; // Pastikan untuk mengimpor fungsi yang benar
  
  // Action Types
  export const FETCH_ROOM_TYPES_REQUEST = 'FETCH_ROOM_TYPES_REQUEST';
  export const FETCH_ROOM_TYPES_SUCCESS = 'FETCH_ROOM_TYPES_SUCCESS';
  export const FETCH_ROOM_TYPES_FAILURE = 'FETCH_ROOM_TYPES_FAILURE';
  export const ADD_ROOM_TYPE_REQUEST = 'ADD_ROOM_TYPE_REQUEST';
  export const ADD_ROOM_TYPE_SUCCESS = 'ADD_ROOM_TYPE_SUCCESS';
  export const ADD_ROOM_TYPE_FAILURE = 'ADD_ROOM_TYPE_FAILURE';
  export const UPDATE_ROOM_TYPE_REQUEST = 'UPDATE_ROOM_TYPE_REQUEST';
  export const UPDATE_ROOM_TYPE_SUCCESS = 'UPDATE_ROOM_TYPE_SUCCESS';
  export const UPDATE_ROOM_TYPE_FAILURE = 'UPDATE_ROOM_TYPE_FAILURE';
  export const DELETE_ROOM_TYPE_REQUEST = 'DELETE_ROOM_TYPE_REQUEST';
  export const DELETE_ROOM_TYPE_SUCCESS = 'DELETE_ROOM_TYPE_SUCCESS';
  export const DELETE_ROOM_TYPE_FAILURE = 'DELETE_ROOM_TYPE_FAILURE';
  
  // Action Creators
  export const fetchRoomTypesRequest = () => ({
    type: FETCH_ROOM_TYPES_REQUEST,
  });
  
  export const fetchRoomTypesSuccess = (roomTypes) => ({
    type: FETCH_ROOM_TYPES_SUCCESS,
    payload: roomTypes,
  });
  
  export const fetchRoomTypesFailure = (error) => ({
    type: FETCH_ROOM_TYPES_FAILURE,
    payload: error,
  });
  
  export const addRoomTypeRequest = () => ({
    type: ADD_ROOM_TYPE_REQUEST,
  });
  
  export const addRoomTypeSuccess = (roomType) => ({
    type: ADD_ROOM_TYPE_SUCCESS,
    payload: roomType,
  });
  
  export const addRoomTypeFailure = (error) => ({
    type: ADD_ROOM_TYPE_FAILURE,
    payload: error,
  });
  
  export const updateRoomTypeRequest = () => ({
    type: UPDATE_ROOM_TYPE_REQUEST,
  });
  
  export const updateRoomTypeSuccess = (roomType) => ({
    type: UPDATE_ROOM_TYPE_SUCCESS,
    payload: roomType,
  });
  
  export const updateRoomTypeFailure = (error) => ({
    type: UPDATE_ROOM_TYPE_FAILURE,
    payload: error,
  });
  
  export const deleteRoomTypeRequest = () => ({
    type: DELETE_ROOM_TYPE_REQUEST,
  });
  
  export const deleteRoomTypeSuccess = (id) => ({
    type: DELETE_ROOM_TYPE_SUCCESS,
    payload: id,
  });
  
  export const deleteRoomTypeFailure = (error) => ({
    type: DELETE_ROOM_TYPE_FAILURE,
    payload: error,
  });
  
  // Thunks
  export const fetchRoomTypes = () => async (dispatch) => {
    dispatch(fetchRoomTypesRequest());
    try {
      const roomTypes = await apiFetchRoomTypes();
      dispatch(fetchRoomTypesSuccess(roomTypes.result));
    } catch (error) {
      dispatch(fetchRoomTypesFailure(error.message));
    }
  };
  
  export const addRoomType = (roomType) => async (dispatch) => {
    dispatch(addRoomTypeRequest());
    try {
      const newRoomType = await apiAddRoomType(roomType);
      dispatch(addRoomTypeSuccess(newRoomType));
    } catch (error) {
      dispatch(addRoomTypeFailure(error.message));
    }
  };
  
  export const updateRoomType = (id, roomType) => async (dispatch) => {
    dispatch(updateRoomTypeRequest());
    try {
      const updatedRoomType = await apiUpdateRoomType(id, roomType);
      dispatch(updateRoomTypeSuccess(updatedRoomType));
    } catch (error) {
      dispatch(updateRoomTypeFailure(error.message));
    }
  };
  
  export const deleteRoomType = (id) => async (dispatch) => {
    dispatch(deleteRoomTypeRequest());
    try {
      await apiDeleteRoomType(id);
      dispatch(deleteRoomTypeSuccess(id));
    } catch (error) {
      dispatch(deleteRoomTypeFailure(error.message));
    }
  };
  